import axiosConfig, { AxiosError } from "axios";
import moment from "moment";
import { NavigationPath } from "src/constants/NavigationPath";
import { AuthResponse, login, logout, overrideUserProfessional } from "src/redux/slices/auth.slice";
import { store } from "src/redux/store";

const axios = axiosConfig.create({
    baseURL: import.meta.env.VITE_APP_BASE_API
})

axios.interceptors.request.use(
    async (config) => {
        try {
            const client_id = import.meta.env.VITE_APP_CLIENT_ID;
            if (client_id)
                config.headers.client_id = client_id;

            let auth = store.getState().auth;
            if (auth.expiresIn && moment.utc(auth.expiresIn).toDate().getTime() < moment.utc().toDate().getTime()) {
                await refreshToken(auth);
                auth = store.getState().auth;
            }

            if (auth && auth.idToken) {
                config.headers.Authorization = `Bearer ${auth.idToken}`;
            }
        }
        catch (error) {
            console.error(error);
            store.dispatch(logout());
            window.location.href = NavigationPath.auth.sign_in;
            window.location.reload();
        }

        return config;
    });

axios.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
        if (error.response?.status === 401) {
            try {
                await refreshToken();
            }
            catch (error) {
                store.dispatch(logout());
                window.location.reload();
                return Promise.reject({ message: "Usuário não autenticado" })
            }
        }
        if (error.response?.status === 403) {
            return Promise.reject({ message: "Recurso proibido" })
        }
        if (error.response?.status === 413) {
            return Promise.reject({ message: "Arquivo muito grande, por favor substitua por um arquivo mais leve" })
        }
        if (error?.response?.data) {
            return Promise.reject(error.response.data);
        }
        if (error.message === 'Network Error') {
            return Promise.reject({ message: "Falha de conexão com o servidor" });
        }

        return Promise.reject(error);
    });

async function refreshToken(auth?: AuthResponse): Promise<void> {
    auth ??= store.getState().auth;

    if (auth && auth.refreshToken) {
        const professional = store.getState().auth.user?.professional ?? null;
        const response = await axiosConfig.post<AuthResponse>(`${import.meta.env.VITE_APP_BASE_API}/api/auth/refresh-token`, { email: auth.user?.email, refreshToken: auth.refreshToken })
        store.dispatch(login(response.data))
        store.dispatch(overrideUserProfessional(professional));
    }
}

export default axios;